/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Home_Faq_Q1_QuestionInputs */

const en_home_faq_q1_question = /** @type {(inputs: Home_Faq_Q1_QuestionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`How do I activate my portal access?`)
};

const fr_home_faq_q1_question = /** @type {(inputs: Home_Faq_Q1_QuestionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Comment activer mon accès au portail ?`)
};

/**
* | output |
* | --- |
* | "How do I activate my portal access?" |
*
* @param {Home_Faq_Q1_QuestionInputs} inputs
* @param {{ locale?: "en" | "fr" }} options
* @returns {LocalizedString}
*/
export const home_faq_q1_question = /** @type {((inputs?: Home_Faq_Q1_QuestionInputs, options?: { locale?: "en" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Home_Faq_Q1_QuestionInputs, { locale?: "en" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_home_faq_q1_question(inputs)
	return fr_home_faq_q1_question(inputs)
});